<template>
  <!-- 全品类运输服务 -->
  <div class="transport">
    <el-row :gutter="20" class="transport-section">
      <el-col
        :span="24"
        v-for="(item, index) in transportData"
        :key="index"
        class="transport-item"
      >
        <div class="content" :class="{ reverse: index % 2 !== 0 }">
          <div class="text-content">
            <div class="text">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
          <img :src="item.imageUrl" alt="运输方式" class="transport-image" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getServiceDetail } from "@/api/serviceDetail.js";
export default {
  data() {
    return {
      transportData: [],
    };
  },
  methods: {
    init(routeName) {
      getServiceDetail(routeName).then((res) => {
        this.transportData = res.data;
        console.log(res.data);
      });
    },
  },
  mounted() {
    const routeName = window.location.pathname.split("/").pop(); // 提取路由名称
    this.init(routeName);
  },
};
</script>


<style scoped lang="scss">
.transport-section {
  opacity: 0; // 初始透明
  animation: fadeInUp 1s ease forwards; // 动画定义

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

.transport-item {
  margin: 50px 0;
}

.content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  &.reverse {
    flex-direction: row-reverse; // 奇数时反转图片和文字位置
  }
}

.transport-image {
  width: 60%;
  max-width: 600px;
  height: 400px;
  margin: 0 20px;
  border-radius: 10px;
  transition: transform 0.3s ease; // 图片放大效果

  &:hover {
    transform: scale(1.05); // 鼠标悬停图片放大
  }
}

.text-content {
  width: 40%;

  .text {
    max-width: 500px;
    padding-left: 30px;
    h3 {
      font-size: 22px;
      font-weight: bold;
      color: #024190;
    }

    p {
      margin-top: 20px;
      // text-indent: 2em; // 首行缩进两格
      line-height: 2; // 设置行高为 1.5 倍字体大小
      font-size: 18px;
      color: #666;
    }
  }
}
</style>
